import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Terminal from './Terminal';
import LandingPage from './LandingPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="*" element={<Terminal />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
